import { Icon } from '@iqueue/ui-kit'
import cn from 'classnames'
import GoToHome from './GoToHome'

export default function NetworkError({ error, className, refetch }) {
  return <div className={ cn('iq-error-view center', className) }>
    <h1><Icon>sick</Icon></h1>
    <h3>Что-то пошло не так...</h3>
    <p>
      <small>
        <b>Error message: { error?.message }</b>
      </small>
    </p>

    { !!refetch && <GoToHome /> }
  </div>
}
